module.exports = __webpack_public_path__ + "static/theworkout-c396d8b46cc2b7af19a3ce373e33e839.jpg";